import { Phone, Mail, MessageCircle, ArrowRight } from "lucide-react";
import { CONTACT, WHATSAPP_URL } from "../lib/contact";
import { useReveal } from "../hooks/useReveal";

export const Contact = () => {
  const ref = useReveal();
  return (
    <section
      id="contacto"
      data-testid="contact-section"
      className="relative py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div ref={ref} className="reveal">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-px bg-[#ca0013]" />
            <span className="font-label text-xs text-[#ca0013]">Contacto</span>
          </div>

          <h2
            data-testid="contact-title"
            className="font-display text-5xl md:text-8xl tracking-tighter leading-[0.92] max-w-5xl"
          >
            ¿Listo para{" "}
            <span className="font-editorial text-[#ca0013] font-normal">
              empezar
            </span>
            ?
          </h2>
          <p className="font-body text-lg text-[#4a4a4a] mt-8 max-w-xl leading-relaxed">
            Cuéntanos sobre tu negocio. Te entregamos un análisis sin costo de tu
            presencia digital y un plan claro de los siguientes pasos.
          </p>

          <div className="mt-12">
            <a
              data-testid="contact-cta-whatsapp-big"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary group inline-flex items-center gap-4 bg-[#ca0013] hover:bg-[#a80010] text-white font-bold px-8 md:px-10 py-5 md:py-6 rounded-full transition-colors font-body text-base md:text-lg"
            >
              <MessageCircle size={22} />
              Analizamos tu negocio sin costo
              <ArrowRight size={20} className="btn-arrow" />
            </a>
          </div>

          <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-6">
            <a
              data-testid="contact-card-whatsapp"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white border border-black/10 p-8 hover:border-[#ca0013] transition-colors"
            >
              <MessageCircle
                size={28}
                strokeWidth={1.5}
                className="text-[#ca0013]"
              />
              <div className="font-label text-xs text-[#4a4a4a] mt-6">
                WhatsApp
              </div>
              <div className="font-display text-2xl md:text-3xl mt-2 tracking-tight group-hover:text-[#ca0013] transition-colors">
                {CONTACT.phone}
              </div>
              <div className="font-editorial text-base text-[#4a4a4a] mt-2">
                respuesta inmediata
              </div>
            </a>

            <a
              data-testid="contact-card-phone"
              href={`tel:${CONTACT.phoneRaw}`}
              className="group bg-white border border-black/10 p-8 hover:border-[#ca0013] transition-colors"
            >
              <Phone size={28} strokeWidth={1.5} className="text-[#ca0013]" />
              <div className="font-label text-xs text-[#4a4a4a] mt-6">
                Teléfono
              </div>
              <div className="font-display text-2xl md:text-3xl mt-2 tracking-tight group-hover:text-[#ca0013] transition-colors">
                {CONTACT.phone}
              </div>
              <div className="font-editorial text-base text-[#4a4a4a] mt-2">
                llámanos directo
              </div>
            </a>

            <a
              data-testid="contact-card-email"
              href={`mailto:${CONTACT.email}`}
              className="group bg-white border border-black/10 p-8 hover:border-[#ca0013] transition-colors"
            >
              <Mail size={28} strokeWidth={1.5} className="text-[#ca0013]" />
              <div className="font-label text-xs text-[#4a4a4a] mt-6">
                Correo
              </div>
              <div className="font-display text-lg md:text-xl mt-2 tracking-tight break-all group-hover:text-[#ca0013] transition-colors">
                {CONTACT.email}
              </div>
              <div className="font-editorial text-base text-[#4a4a4a] mt-2">
                escríbenos
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
